export default __webpack_public_path__ + "static/kimberlyclark-c7729bed70422cba47979977b587d0ea.png";